/* -------------------------------------------------------------------------- */
/*                                 Schema Units                               */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const unit = new schema.Entity('units', {}, { idAttribute: 'unitId' });
export const units = new schema.Array(unit);
